module.exports = __webpack_public_path__ + "static/media/25.56fec15f.webp";